import React from "react";
import { CheckIcon, XMarkIcon } from "@heroicons/react/24/solid";

const Services = () => {
  return (
    <section className="py-20" id="our-service">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-12">Our Packages</h2>

        {/* Packages Banner */}
        <div className="flex flex-wrap justify-center gap-8">
          <div className="bg-white shadow-lg rounded-lg w-full md:w-1/5">
            <div className="bg-blue-300 text-white text-xl font-semibold text-center py-2 rounded-t-lg">
              Bronze
            </div>
            <div className="p-4">
              <p className="text-2xl font-bold text-center">10%</p>
              <ul className="mt-4 text-gray-600">
                <li className="flex items-center">
                  <CheckIcon className="h-5 w-5 text-green-500 mr-2" />{" "}
                  Customized Pricing Strategy
                </li>
                <li className="flex items-center">
                  <CheckIcon className="h-5 w-5 text-green-500 mr-2" /> AI
                  Powered Automation
                </li>
              </ul>
            </div>
          </div>

          <div className="bg-white shadow-lg rounded-lg w-full md:w-1/5">
            <div className="bg-blue-400 text-white text-xl font-semibold text-center py-2 rounded-t-lg">
              Silver
            </div>
            <div className="p-4">
              <p className="text-2xl font-bold text-center">15%</p>
              <ul className="mt-4 text-gray-600">
                <li className="flex items-center">
                  <CheckIcon className="h-5 w-5 text-green-500 mr-2" />{" "}
                  Customized Pricing Strategy
                </li>
                <li className="flex items-center">
                  <CheckIcon className="h-5 w-5 text-green-500 mr-2" /> AI
                  Powered Automation
                </li>
                <li className="flex items-center">
                  <CheckIcon className="h-5 w-5 text-green-500 mr-2" /> Online
                  management
                </li>
              </ul>
            </div>
          </div>

          <div className="bg-white shadow-lg rounded-lg w-full md:w-1/5">
            <div className="bg-blue-500 text-white text-xl font-semibold text-center py-2 rounded-t-lg">
              Gold
            </div>
            <div className="p-4">
              <p className="text-2xl font-bold text-center">20%</p>
              <ul className="mt-4 text-gray-600">
                <li className="flex items-center">
                  <CheckIcon className="h-5 w-5 text-green-500 mr-2" />{" "}
                  Customized Pricing Strategy
                </li>
                <li className="flex items-center">
                  <CheckIcon className="h-5 w-5 text-green-500 mr-2" /> AI
                  Powered Automation
                </li>
                <li className="flex items-center">
                  <CheckIcon className="h-5 w-5 text-green-500 mr-2" /> Online
                  management
                </li>
                <li className="flex items-center">
                  <CheckIcon className="h-5 w-5 text-green-500 mr-2" />{" "}
                  In-Person management
                </li>
              </ul>
            </div>
          </div>

          <div className="bg-white shadow-lg rounded-lg w-full md:w-1/5">
            <div className="bg-blue-600 text-white text-xl font-semibold text-center py-2 rounded-t-lg">
              Platinum
            </div>
            <div className="p-4">
              <p className="text-2xl font-bold text-center">25%</p>
              <ul className="mt-4 text-gray-600">
                <li className="flex items-center">
                  <CheckIcon className="h-5 w-5 text-green-500 mr-2" />{" "}
                  Customized Pricing Strategy
                </li>
                <li className="flex items-center">
                  <CheckIcon className="h-5 w-5 text-green-500 mr-2" /> AI
                  Powered Automation
                </li>
                <li className="flex items-center">
                  <CheckIcon className="h-5 w-5 text-green-500 mr-2" /> Online
                  management
                </li>
                <li className="flex items-center">
                  <CheckIcon className="h-5 w-5 text-green-500 mr-2" />{" "}
                  In-Person management
                </li>
                <li className="flex items-center">
                  <CheckIcon className="h-5 w-5 text-green-500 mr-2" />{" "}
                  Operation Supplies
                </li>
                <li className="flex items-center">
                  <CheckIcon className="h-5 w-5 text-green-500 mr-2" />{" "}
                  Maintainance Contribution
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Comparison Table */}
        <div className="mt-16">
            <div className="overflow-x-auto">
              <table className="min-w-full bg-white rounded-lg overflow-hidden shadow-lg">
                <thead className="bg-blue-600">
                  <tr>
                    <th className="py-3 px-6 text-left text-white font-semibold text-lg">
                      Service
                    </th>
                    <th className="py-3 px-6 text-center text-white font-semibold text-lg">
                      Bronze
                    </th>
                    <th className="py-3 px-6 text-center text-white font-semibold text-lg">
                      Silver
                    </th>
                    <th className="py-3 px-6 text-center text-white font-semibold text-lg">
                      Gold
                    </th>
                    <th className="py-3 px-6 text-center text-white font-semibold text-lg">
                      Platinum
                    </th>
                    <th className="py-3 px-6 text-center text-white font-semibold text-lg">
                      Competitors
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {/* Pricing Strategy */}
                  <tr className="border-b">
                    <td className="py-4 px-6 text-left">
                      Customized Pricing Strategy
                    </td>
                    <td className="py-4 px-6 text-center">
                      <CheckIcon className="h-6 w-6 text-green-500 inline" />
                    </td>
                    <td className="py-4 px-6 text-center">
                      <CheckIcon className="h-6 w-6 text-green-500 inline" />
                    </td>
                    <td className="py-4 px-6 text-center">
                      <CheckIcon className="h-6 w-6 text-green-500 inline" />
                    </td>
                    <td className="py-4 px-6 text-center">
                      <CheckIcon className="h-6 w-6 text-green-500 inline" />
                    </td>
                    <td className="py-4 px-6 text-center">
                      <XMarkIcon className="h-6 w-6 text-red-500 inline" />
                    </td>
                  </tr>
                  {/* AI Powered Automation */}
                  <tr className="border-b bg-gray-50">
                    <td className="py-4 px-6 text-left">
                      AI Powered Automation
                    </td>
                    <td className="py-4 px-6 text-center">
                      <CheckIcon className="h-6 w-6 text-green-500 inline" />
                    </td>
                    <td className="py-4 px-6 text-center">
                      <CheckIcon className="h-6 w-6 text-green-500 inline" />
                    </td>
                    <td className="py-4 px-6 text-center">
                      <CheckIcon className="h-6 w-6 text-green-500 inline" />
                    </td>
                    <td className="py-4 px-6 text-center">
                      <CheckIcon className="h-6 w-6 text-green-500 inline" />
                    </td>
                    <td className="py-4 px-6 text-center">
                      <span className="text-500">Rule based</span>
                    </td>
                  </tr>
                  {/* Online Management */}
                  <tr className="border-b bg-gray-50">
                    <td className="py-4 px-6 text-left">Online Management</td>
                    <td className="py-4 px-6 text-center">
                      <XMarkIcon className="h-6 w-6 text-red-500 inline" />
                    </td>
                    <td className="py-4 px-6 text-center">
                      <CheckIcon className="h-6 w-6 text-green-500 inline" />
                    </td>
                    <td className="py-4 px-6 text-center">
                      <CheckIcon className="h-6 w-6 text-green-500 inline" />
                    </td>
                    <td className="py-4 px-6 text-center">
                      <CheckIcon className="h-6 w-6 text-green-500 inline" />
                    </td>
                    <td className="py-4 px-6 text-center">
                      <CheckIcon className="h-6 w-6 text-green-500 inline" />
                    </td>
                  </tr>
                  {/* In-Person Management */}
                  <tr className="border-b">
                    <td className="py-4 px-6 text-left">
                      In-Person Management
                    </td>
                    <td className="py-4 px-6 text-center">
                      <XMarkIcon className="h-6 w-6 text-red-500 inline" />
                    </td>
                    <td className="py-4 px-6 text-center">
                      <XMarkIcon className="h-6 w-6 text-red-500 inline" />
                    </td>
                    <td className="py-4 px-6 text-center">
                      <CheckIcon className="h-6 w-6 text-green-500 inline" />
                    </td>
                    <td className="py-4 px-6 text-center">
                      <CheckIcon className="h-6 w-6 text-green-500 inline" />
                    </td>
                    <td className="py-4 px-6 text-center">
                      <span className="text-500">Invoiced</span>
                    </td>
                  </tr>
                  {/* Supplies */}
                  <tr className="border-b bg-gray-50">
                    <td className="py-4 px-6 text-left">Supplies</td>
                    <td className="py-4 px-6 text-center">
                      <XMarkIcon className="h-6 w-6 text-red-500 inline" />
                    </td>
                    <td className="py-4 px-6 text-center">
                      <XMarkIcon className="h-6 w-6 text-red-500 inline" />
                    </td>
                    <td className="py-4 px-6 text-center">
                      <XMarkIcon className="h-6 w-6 text-red-500 inline" />
                    </td>
                    <td className="py-4 px-6 text-center">
                      <CheckIcon className="h-6 w-6 text-green-500 inline" />
                    </td>
                    <td className="py-4 px-6 text-center">
                      <span className="text-500">Invoiced</span>
                    </td>
                  </tr>
                  {/* Cleaning */}
                  <tr className="border-b bg-gray-50">
                    <td className="py-4 px-6 text-left">Cleaning</td>
                    <td className="py-4 px-6 text-center">
                      <span className="text-500">Per visit</span>
                    </td>
                    <td className="py-4 px-6 text-center">
                      <span className="text-500">Per visit</span>
                    </td>
                    <td className="py-4 px-6 text-center">
                      <span className="text-500">Per visit</span>
                    </td>
                    <td className="py-4 px-6 text-center">
                      <span className="text-500">Per visit</span>
                    </td>
                    <td className="py-4 px-6 text-center">
                      <span className="text-500">Per visit</span>
                    </td>
                  </tr>
                  {/* Listing Consulting */}
                  <tr className="border-b">
                    <td className="py-4 px-6 text-left">Listing Consulting</td>
                    <td className="py-4 px-6 text-center">
                      <span className="text-500">Add-on</span>
                    </td>
                    <td className="py-4 px-6 text-center">
                      <span className="text-500">Add-on</span>
                    </td>
                    <td className="py-4 px-6 text-center">
                      <span className="text-500">Add-on</span>
                    </td>
                    <td className="py-4 px-6 text-center">
                      <span className="text-500">Add-on</span>
                    </td>
                    <td className="py-4 px-6 text-center">
                      <span className="text-500">Add-on</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            {/* Legend */}
            <div className="mt-4 text-center">
              <span className="inline-flex items-center mr-4">
                <CheckIcon className="h-5 w-5 text-green-500 mr-1" />
                Included
              </span>
              <span className="inline-flex items-center">
                <XMarkIcon className="h-5 w-5 text-red-500 mr-1" />
                Not Included
              </span>
            </div>
          </div>
      </div>
    </section>
  );
};

export default Services;
